export default function clientsSay() {

    const clientsSlider = new Swiper(".js-clients-slider", {
        slidesPerView: 1,
        loop: false,
        centered: false,
        spaceBetween: 0,
        speed: 500,
        navigation: {
            nextEl: ".clients-say__nav .swiper-button-next",
            prevEl: ".clients-say__nav .swiper-button-prev",
        },
    });
}

document.addEventListener('DOMContentLoaded', () => {
    clientsSay();
})